import { useState } from "react";
import { toast } from "@/lib/toast";
import { supabase } from "../lib/supabase";
import BrandLogo from "../components/shared/BrandLogo";
import { useNavigate } from "react-router-dom";
import { useIsMounted } from "../hooks/useIsMounted";
const PAGE  = "min-h-[100dvh] pb-[env(safe-area-inset-bottom)] bg-[#f4f8fc] dark:bg-[#050d1e]";
const INPUT = "w-full h-12 px-4 rounded-[14px] border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 text-[15px] text-slate-800 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500 focus:bg-white dark:focus:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-brand/30";

export default function RequestAccess() {
  const navigate  = useNavigate();
  const isMounted = useIsMounted();
  const [email,   setEmail]   = useState("");
  const [name,    setName]    = useState("");
  const [loading, setLoading] = useState(false);

  const handleRequest = async (e) => {
    e.preventDefault();
    if (loading) return;
    if (!email || !name) { toast.error("Completa todos los campos"); return; }
    setLoading(true);
    try {
      const { error } = await supabase.from("access_requests").insert([{
        email: email.trim().toLowerCase(),
        name,
        status: "pending",
      }]);
      if (error) {
        if (error.code === "23505") { toast.info("Ya existe una solicitud pendiente para este correo."); return; }
        throw error;
      }
      toast.success("Solicitud enviada correctamente");
      navigate("/request-sent", { replace: true });
    } catch (err) {
      toast.error("No se pudo enviar la solicitud");
    } finally {
      if (isMounted()) setLoading(false);
    }
  };

  return (
    <div className={`${PAGE} flex flex-col px-4`} style={{ paddingTop: "env(safe-area-inset-top)" }}>

      <div className="flex-1 flex flex-col items-center justify-center py-8">

        {/* Wordmark */}
        <div className="text-center mb-7">
          <BrandLogo variant="auto" className="w-14 h-14 mx-auto mb-2.5 object-contain" />
          <h1 className="text-[22px] font-bold text-brand dark:text-blue-400 tracking-tight">Kéves App</h1>
          <p className="text-[12px] text-slate-400 dark:text-slate-500 mt-1">El equipo revisará tu solicitud pronto</p>
        </div>

        {/* Card */}
        <form
          onSubmit={handleRequest}
          className="w-full max-w-md bg-white dark:bg-slate-900 rounded-[28px] shadow-[0_4px_24px_rgba(0,0,0,0.08)] dark:shadow-[0_8px_32px_rgba(0,0,0,0.4)] border border-slate-100 dark:border-slate-800 p-6 space-y-4"
        >
          <div>
            <h2 className="text-[18px] font-bold text-slate-800 dark:text-slate-100 mb-0.5">Solicitar acceso</h2>
            <p className="text-[13px] text-slate-400 dark:text-slate-500">Exclusivo para pastores</p>
            <p className="text-[12px] text-slate-400 dark:text-slate-500 mt-1 leading-relaxed">
              Los coordinadores son invitados directamente por el pastor desde su panel.
            </p>
          </div>

          <input
            type="text"
            placeholder="Nombre completo"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className={INPUT}
            required
          />
          <input
            type="email"
            placeholder="Correo electrónico"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={INPUT}
            required
          />

          <button
            type="submit"
            disabled={loading}
            className="w-full h-12 bg-brand text-white rounded-[14px] font-semibold text-[15px] shadow-sm transition-all duration-200 ease-out hover:brightness-105 active:scale-[0.98] disabled:opacity-50"
          >
            {loading ? "Enviando…" : "Solicitar acceso"}
          </button>
        </form>

        <p className="text-[13px] text-slate-400 dark:text-slate-500 mt-5">
          <button onClick={() => navigate("/login?view=pastor")} className="text-brand hover:underline">
            ← Volver al inicio de sesión
          </button>
        </p>

      </div>
    </div>
  );
}
